import { createSlice } from '@reduxjs/toolkit';
import { AxiosResponseModel } from '../../@types/base';
import axios from '../../utils/axios';
import { CONSTS } from './const';
import { dispatch } from '../store';
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import { FeatureLogsResponse } from '../../@types/features';

// ----------------------------------------------------------------------

type SettingsState = {
  isProfileLoading: boolean;
  profileError: string | null;
};


const initialState: SettingsState = {
  isProfileLoading: true,
  profileError: null
};

const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {

    setProfileLoading(state, action) {
      state.isProfileLoading = action.payload;
    },
    setProfileError(state, action) {
      state.profileError = action.payload;
    }

  }
});

// Reducer
export default slice.reducer;


export async function getFeatureLogs(
  limit: number,
  offset: number
) {
  dispatch(slice.actions.setProfileLoading(true));

  try {
    const response: AxiosResponseModel<FeatureLogsResponse[]> = await axios
      .get(`${CONSTS.FEATURES_LOGS_GET_ALL}?limit=${limit}&offset=${offset}`)
      .catch((error) => {
        dispatch(slice.actions.setProfileError(response?.data?.error || ''));
        dispatch(slice.actions.setProfileLoading(false));
        if (error.response) {
          return error.response.data;
        }
        return null;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.setProfileError(null));
      dispatch(slice.actions.setProfileLoading(false));
      return response || [];
    }
    dispatch(slice.actions.setProfileError(response?.data?.error || ''));
    dispatch(slice.actions.setProfileLoading(false));

    return null;
  } catch (error: any) {
    dispatch(slice.actions.setProfileError(''));
    dispatch(slice.actions.setProfileLoading(false));
    return null;
  }

}

